import { addToast } from 'core/notifications';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import kebabCase from 'lodash/kebabCase';
import axios from '@/util/axios';

import global from './i18nStrings.json';

const convertKeysToKebabCase = (object) =>
  Object.fromEntries(
    Object.entries(object || {}).map(([snakeCase, value]) => [
      kebabCase(snakeCase).replace(/-plural$/, '_plural'), // preserve pluralisation
      value,
    ]),
  );

export default async ({ key, shouldLoadTranslations, strings } = {}) => {
  const ns = ['app', 'global'];
  const lng = document.documentElement.lang;
  const fallbackLng = 'en';
  const resources = { [lng]: {}, [fallbackLng]: { app: strings || {}, global } };
  const translationPaths = (key || shouldLoadTranslations) && window.Intellum.translation_paths;

  if (translationPaths) {
    await Promise.all(
      Object.entries(resources).map(async ([locale, resource]) => {
        const translationPath = translationPaths[locale];

        if (!translationPath) return;

        try {
          const {
            data: { [locale]: data },
          } = await axios.get(translationPath);

          resources[locale] = {
            ...resource,
            ...(key && { app: { ...resource.app, ...convertKeysToKebabCase(data[key]) } }),
            global: { ...resource.global, ...convertKeysToKebabCase(data.global) },
          };
        } catch {
          addToast('Error loading translations.', 'error');
        }
      }),
    );
  }

  i18n.use(initReactI18next).init({
    debug: process.env.NODE_ENV === 'development',
    defaultNS: ns[0],
    fallbackLng,
    fallbackNS: ns,
    interpolation: { escapeValue: false, prefix: '%{', suffix: '}' },
    lng,
    ns,
    resources,
  });
};
